
import { Layout } from '@/types/Layout';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class FlexibleLayout extends Vue {
    @Prop({ type: Object, default: () => ({ left: [], right: [], center: [] }) })
    private layout: Layout;

    @Prop({ type: Number, default: 4 })
    private leftColSpan: number;

    @Prop({ type: Number, default: 4 })
    private centerColSpan: number;

    @Prop({ type: Number, default: 4 })
    private rightColSpan: number;

    @Prop({type: Boolean, default: false })
    private columnsScrollable: boolean;
}
